import { computed } from 'vue'
import { format } from 'date-fns'

import { useEventBus } from '@/composables/event_bus'
import { useAiSuggestionsStore } from '@/stores/ai-suggestions'
import { useUserStore } from '@/stores/user'

export function useAiSuggestionsNotification() {
  const eventBus = useEventBus()
  const aiSuggestionsStore = useAiSuggestionsStore()
  const userStore = useUserStore()

  // Admin entities carry the names and are the ones the user can enter.
  const entities = computed(() => {
    const counts = new Map(
      aiSuggestionsStore.pendingEntities.map((item) => [
        item.entity_id,
        item.pending_count,
      ])
    )
    return userStore.allAdminEntities
      .flatMap((entity) => {
        const pending_count = counts.get(entity.id)
        return pending_count === undefined ? [] : [{ ...entity, pending_count }]
      })
      .sort((a, b) => a.name.localeCompare(b.name))
  })

  async function prepare(): Promise<boolean> {
    const today = format(new Date(), 'yyyy-MM-dd')
    if (
      userStore.settings.additional.last_ai_suggestions_notification_date ===
      today
    ) {
      return false
    }

    try {
      await aiSuggestionsStore.fetchPendingEntities()
    } catch {
      // Unrequested background check: a toast on every load would be worse.
      return false
    }
    if (!entities.value.length) {
      return false
    }

    // Saved before showing: Review's session change would cancel a pending save.
    await userStore
      .saveUserAdditionalSettings({
        last_ai_suggestions_notification_date: today,
      })
      .catch((err) => {
        eventBus.emit('error', err)
      })
    return true
  }

  return { prepare, entities }
}
